import React from 'react';
import DeleteIcon from "@mui/icons-material/Delete";

const DeleteIconRenderer = (params) => (
    <div>
      <DeleteIcon
        onClick={(e) => {
          deleteFocusArea(params);
        }}
      />
    </div>
  );
export default DeleteIconRenderer;